var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"45":1,"87":1,"128":1,"771":1,"789":1,"880":1,"976":1,"1049":1,"1114":1,"1162":1,"1551":1,"1632":1,"1711":1,"1764":1,"1958":1,"2052":1,"2203":1,"2268":1,"2354":1,"2361":1,"2654":1,"2858":1,"3004":1,"3207":1,"3323":1,"3402":1,"3414":1,"3538":1,"3608":1,"3869":1,"3871":1,"4024":1,"4089":1,"4344":1,"4555":1,"4663":1,"4741":1,"4825":1,"4839":1,"5207":1,"5268":1,"5285":1,"5406":1,"5904":1,"6114":1,"6280":1,"6352":1,"6604":1,"6888":1,"6965":1,"7050":1,"7060":1,"7148":1,"7288":1,"7572":1,"7808":1,"7875":1,"7882":1,"7901":1,"7968":1,"8078":1,"8205":1,"8239":1,"8249":1,"8461":1,"8569":1,"8741":1,"8847":1,"8921":1,"9080":1,"9163":1,"9272":1,"9284":1,"9349":1,"9405":1,"9483":1,"9547":1,"9722":1,"9987":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr